import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('STOCKINSTRUMENTALS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class StockInstrumentalsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'stockinstrumentals' como el nombre del recurso a la clase base
    super('stockinstrumentals');
    log.debug('Servicio de Inventario de instrumentales inicializado');
  }

}
